import React from 'react';
import styles from './Tabs.module.css';

class Tabs extends React.Component {
  constructor(props) {
    super(props);
    this.state = { active: props.defaultTab || (props.tabs && props.tabs[0]?.key) || '' };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.activeTab !== this.props.activeTab && this.props.activeTab !== undefined) {
      this.setState({ active: this.props.activeTab });
    }
  }

  render() {
    const { tabs = [], children, variant = 'line', onChange } = this.props;
    const active = this.props.activeTab !== undefined ? this.props.activeTab : this.state.active;

    return (
      <div className={styles.wrap}>
        <div className={[styles.bar, styles[variant]].join(' ')}>
          {tabs.map(tab => (
            <button
              key={tab.key}
              className={[styles.tab, active === tab.key ? styles.active : ''].join(' ')}
              onClick={() => {
                if (this.props.activeTab === undefined) this.setState({ active: tab.key });
                onChange && onChange(tab.key);
              }}
              disabled={tab.disabled}
            >
              {tab.icon && <span className={styles.tabIcon}>{tab.icon}</span>}
              {tab.label}
              {tab.count !== undefined && (
                <span className={styles.count}>{tab.count}</span>
              )}
            </button>
          ))}
        </div>
        <div className={styles.content}>{children}</div>
      </div>
    );
  }
}

export default Tabs;
